/**

 * Tenant config parsing — Firestore is the sole source of truth.

 */

/**

 *

 * @param {string} tenantId

 * @param {object} firestoreData - Raw Firestore document fields

 * @returns {{ config: object, source: 'firestore' }}

 */

export function parseTenantConfig(tenantId, firestoreData) {

  if (!firestoreData || typeof firestoreData !== 'object') {

    throw new Error(`Tenant config missing for "${tenantId}"`);

  }



  const branding = firestoreData.branding || {};



  return {

    config: {

      tenantId: firestoreData.tenantId || tenantId,

      slug: firestoreData.slug || tenantId,

      displayName: firestoreData.displayName || tenantId,

      status: firestoreData.status || 'active',

      branding: {

        appTitle: branding.appTitle || tenantId,

        logoPath: branding.logoPath || '',

        logoAlt: branding.logoAlt || firestoreData.displayName || tenantId,

        primaryColor: branding.primaryColor || '#d32f2f',

        accentColor: branding.accentColor || null,

        primaryHoverColor: branding.primaryHoverColor || null,

      },

      authPolicy: firestoreData.authPolicy || {},

      modules: firestoreData.modules || {},

      footer: firestoreData.footer || null,

      chatListGroups: Array.isArray(firestoreData.chatListGroups)
        ? firestoreData.chatListGroups
        : [],

      articleListGroups: Array.isArray(firestoreData.articleListGroups)
        ? firestoreData.articleListGroups
        : [],

      articleEssentialSectionSubtitle:
        typeof firestoreData.articleEssentialSectionSubtitle === 'string'
          ? firestoreData.articleEssentialSectionSubtitle
          : null,

    },

    source: 'firestore',

  };

}


